module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chain"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('shopmng.crumbs.L1')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group panel-select-group__justify"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v(_vm._s(_vm.$t('shopmng.title.baseInfo')))]), _vm._v(" "), _c('div', {
    class: _vm.lang === 'ja' ? 'panel-header-btn panel-header-btn-ja' : 'panel-header-btn',
    attrs: {
      "type": "primary",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changePass('chain', _vm.shop.mobile)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('shopmng.panel.btn.editPwd')))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "info_wrapper"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title_en"
  }, [_vm._v(_vm._s(_vm.$t('shopmng.panel.shopName')))]), _vm._v(" "), _c('div', {
    staticClass: "info__sign"
  }, [_vm._v(":")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.shopname))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title_en"
  }, [_vm._v(_vm._s(_vm.$t('shopmng.panel.loginAccount')))]), _vm._v(" "), _c('div', {
    staticClass: "info__sign"
  }, [_vm._v(":")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.mobile))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title_en"
  }, [_vm._v(_vm._s(_vm.$t('shopmng.panel.mID')))]), _vm._v(" "), _c('div', {
    staticClass: "info__sign"
  }, [_vm._v(":")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.id))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v(_vm._s(_vm.$t('shopmng.title.subInfo')))]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [(_vm.role.country !== 'TH') ? _c('div', {
    staticClass: "panel-header-btn__associate",
    style: (_vm.lang === 'en' ? 'width:200px' : ''),
    on: {
      "click": _vm.editShopDown
    }
  }, [_c('i', {
    staticClass: "icon-download"
  }), _vm._v("\n            " + _vm._s(_vm.$t('shopmng.panel.btn.listDown')) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "panel-edit-btn__subshopnum",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubShopNum($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('shopmng.panel.btn.editSubTag')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.pageShopData.list,
      "row-class-name": "el-table__row_fix"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "shop_name",
      "label": _vm.$t('shopmng.panel.table.subName')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": _vm.$t('shopmng.panel.table.loginAccount')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "join_time",
      "label": _vm.$t('shopmng.panel.table.regTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": _vm.$t('shopmng.panel.table.sID')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tag",
      "label": _vm.$t('shopmng.panel.table.subTag')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('shopmng.panel.table.op'),
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "el-button__fix",
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showDetail(scope)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('shopmng.panel.table.detail')))]), _vm._v(" "), _c('el-dropdown', [_c('span', {
          staticClass: "el-dropdown-link el-dropdown-link__fix"
        }, [_vm._v("\n                " + _vm._s(_vm.$t('shopmng.panel.table.more'))), _c('i', {
          staticClass: "el-icon-caret-bottom el-icon--right"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          staticClass: "el-dropdown-menu__fix collect",
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          staticClass: "el-dropdown-item__fix",
          nativeOn: {
            "click": function($event) {
              return _vm.changePass('single', scope.row.mobile)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('shopmng.panel.table.editPwd')) + "\n                ")]), _vm._v(" "), _c('el-dropdown-item', {
          staticClass: "el-dropdown-item__fix",
          nativeOn: {
            "click": function($event) {
              return _vm.confirmDeleteShop(scope.row.uid)
            }
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.$t('shopmng.panel.table.delSub')) + "\n                ")])], 1)], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.pageShopData.count >= 10) ? _c('div', {
    staticClass: "pagination_wrapper"
  }, [_c('el-pagination', {
    ref: "page",
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": +_vm.pageShopData.count,
      "current-page": _vm.currentpage
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.currentChange
    }
  })], 1) : _c('div', {
    staticClass: "table_placeholder"
  })]), _vm._v(" "), _c('el-dialog', {
    staticClass: "detail_dialog",
    attrs: {
      "title": _vm.$t('shopmng.dialog.shopDetail')
    },
    model: {
      value: (_vm.isShowDetail),
      callback: function($$v) {
        _vm.isShowDetail = $$v
      },
      expression: "isShowDetail"
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 6
    }
  }, [_vm._v(_vm._s(_vm.$t('shopmng.dialog.loginAccount')))]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.detailData.mobile))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 6
    }
  }, [_vm._v(_vm._s(_vm.$t('shopmng.dialog.shopName')))]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.detailData.shopname))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 6
    }
  }, [_vm._v(_vm._s(_vm.$t('shopmng.dialog.address')))]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.detailData.address))])], 1), _vm._v(" "), (_vm.role.country !== 'ID') ? _c('div', [_c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 6
    }
  }, [_vm._v(_vm._s(_vm.$t('shopmng.dialog.mobile')))]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.detailData.telephone || '无'))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 6
    }
  }, [_vm._v(_vm._s(_vm.$t('shopmng.dialog.cardHolder')))]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.detailData.bankuser))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 6
    }
  }, [_vm._v(_vm._s(_vm.$t('shopmng.dialog.bankAccount')))]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.detailData.bankaccount))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 6
    }
  }, [_vm._v(_vm._s(_vm.$t('shopmng.dialog.bankName')))]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 14
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.detailData.headbankname))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.detailData.bankname))])])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('shopmng.dialog.editPwd'),
      "visible": _vm.showChangePass,
      "custom-class": "mydialog",
      "top": "20%",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showChangePass = $event
      },
      "close": function($event) {
        return _vm.handleClose('form')
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.formrules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('shopmng.dialog.loginAccount')
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.userName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('shopmng.dialog.inputNewPwd'),
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "auto-complete": "new-password",
      "type": "password",
      "placeholder": _vm.$t('shopmng.dialog.msg.m1')
    },
    model: {
      value: (_vm.form.pass),
      callback: function($$v) {
        _vm.$set(_vm.form, "pass", $$v)
      },
      expression: "form.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('shopmng.dialog.confirmNewPwd'),
      "prop": "repass"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "auto-complete": "new-password",
      "type": "password",
      "placeholder": _vm.$t('shopmng.dialog.msg.m2')
    },
    model: {
      value: (_vm.form.repass),
      callback: function($$v) {
        _vm.$set(_vm.form, "repass", $$v)
      },
      expression: "form.repass"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.showChangePass = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('shopmng.dialog.cancel')))]), _vm._v(" "), _c('div', {
    staticClass: "submit",
    on: {
      "click": _vm.submit
    }
  }, [(_vm.iconShow) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v(_vm._s(_vm.$t('shopmng.dialog.ok')))])])])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "mydialog downlog",
    attrs: {
      "title": _vm.$t('shopmng.panel.btn.listDown'),
      "visible": _vm.showDown,
      "custom-class": "mydialog_haiwai",
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDown = $event
      }
    }
  }, [_c('el-form', {
    ref: "downForm",
    staticClass: "down-sub-shop",
    attrs: {
      "label-position": "left",
      "model": _vm.downForm
    }
  }, [_c('div', {
    staticClass: "desc",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('shopmng.dialog.downTip')) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "shop"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedShopChange
    },
    model: {
      value: (_vm.downForm.shop),
      callback: function($$v) {
        _vm.$set(_vm.downForm, "shop", $$v)
      },
      expression: "downForm.shop"
    }
  }, _vm._l((_vm.shopData.list), function(item, index) {
    return (index !== 0) ? _c('el-checkbox', {
      key: item.uid,
      attrs: {
        "label": item.uid
      }
    }, [_vm._v(_vm._s(item.shop_name))]) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.downForm.checkAll),
      callback: function($$v) {
        _vm.$set(_vm.downForm, "checkAll", $$v)
      },
      expression: "downForm.checkAll"
    }
  }, [_vm._v(_vm._s(_vm.$t('shopmng.dialog.all')))]), _vm._v(" "), _c('span', {
    staticClass: "footer-right"
  }, [_c('div', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.showDown = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.cancel')))]), _vm._v(" "), _c('div', {
    staticClass: "submit",
    on: {
      "click": _vm.downShopList
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconShow),
      expression: "iconShow"
    }],
    staticClass: "el-icon-loading"
  }), _vm._v(_vm._s(_vm.$t('shopmng.dialog.confirm')))])])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "mydialog",
    attrs: {
      "title": _vm.$t('shopmng.dialog.editSubTag'),
      "visible": _vm.showEditSubShopNum,
      "custom-class": "mydialog_haiwai",
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.showEditSubShopNum = $event
      },
      "close": _vm.refreshSubShopData
    }
  }, [_c('el-form', {
    ref: "form-edit-subshop-num",
    staticClass: "edit-sub-tag",
    attrs: {
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "desc",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('shopmng.dialog.diaTip')) + "\n      ")]), _vm._v(" "), _vm._l((_vm.shopData.list), function(shop, index) {
    return (index !== 0) ? _c('el-form-item', {
      key: index
    }, [_c('el-tooltip', {
      staticClass: "subshoptip",
      attrs: {
        "placement": "bottom",
        "content": shop.shop_name
      }
    }, [_c('label', {
      staticStyle: {
        "width": "140px"
      }
    }, [_vm._v(_vm._s(shop.shop_name))])]), _vm._v(" "), _c('el-input', {
      style: (_vm.lang === 'ja' ? 'width:98%' : 'width:65%'),
      attrs: {
        "size": "small",
        "placeholder": _vm.$t('shopmng.dialog.validateText')
      },
      on: {
        "blur": function($event) {
          return _vm.updateShopTag(shop)
        }
      },
      model: {
        value: (shop.tag),
        callback: function($$v) {
          _vm.$set(shop, "tag", $$v)
        },
        expression: "shop.tag"
      }
    })], 1) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "submit",
    on: {
      "click": _vm.refreshSubShopData
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconShow),
      expression: "iconShow"
    }],
    staticClass: "el-icon-loading"
  }), _vm._v(_vm._s(_vm.$t('shopmng.dialog.confirm')))])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('shopmng.dialog.notice'),
      "visible": _vm.showDeleteShopConfirm,
      "custom-class": "mydialog pass",
      "top": "20%",
      "show-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showDeleteShopConfirm = $event
      },
      "close": function($event) {
        return _vm.handleClose('pwdform')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t('shopmng.dialog.noticeTip')))]), _vm._v(" "), _c('el-form', {
    ref: "pwdform",
    attrs: {
      "model": _vm.formpwd,
      "rules": _vm.formrules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "primeaccountpwd"
    }
  }, [_c('el-input', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "placeholder": _vm.$t('shopmng.dialog.validateText2'),
      "auto-complete": "new-password",
      "type": "password"
    },
    model: {
      value: (_vm.formpwd.primeaccountpwd),
      callback: function($$v) {
        _vm.$set(_vm.formpwd, "primeaccountpwd", $$v)
      },
      expression: "formpwd.primeaccountpwd"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "submit",
    on: {
      "click": function($event) {
        return _vm.checkPrimeShopPwd('pwdform', this)
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconShow),
      expression: "iconShow"
    }],
    staticClass: "el-icon-loading"
  }), _vm._v(_vm._s(_vm.$t('shopmng.dialog.ok')) + "\n      ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-60924776"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/chainmanage/chainmanage.vue
// module id = 919
// module chunks = 0